
    // this file was auto generated by python script
    import Triangle from './Triangle';
    export default Triangle;
    